import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import toNumber from 'lodash/toNumber'
import { Modal, ErrorBoundary } from 'components'
import db from '../../firebase'
import { getPlanParams } from 'store/selectors'

class EmailForm extends React.Component {
  state = {
    error: true,
  }

  validate = value => {
    if (/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/g.test(value)) {
      return false
    }
    return true
  }

  handleChange = e => this.setState({ error: this.validate(e.target.value) })

  handleSubmit = e => {
    e.preventDefault()

    const { planParams, sessionId, history } = this.props
    const active = planParams.profile.planName.includes('WAPLWFP')
    db.doc(`shared-plans/${sessionId}`)
      .set({
        ...planParams,
        active,
        email: this.emailInput.value,
        timestamp: toNumber(moment().format('X')),
      })
      .then(() => {
        history.replace('/share')
      })
  }

  componentDidMount() {
    this.setState({ error: this.validate('') })
  }

  render() {
    const { error } = this.state
    return (
      <form className="email" onSubmit={this.handleSubmit}>
        <ErrorBoundary>
          <label>Email</label>
          <input
            type="email"
            ref={input => {
              this.emailInput = input
            }}
            onChange={this.handleChange}
          />
          <div>
            <button disabled={error} type="submit">
              Next
            </button>
          </div>
        </ErrorBoundary>
      </form>
    )
  }
}

function Email(props) {
  return (
    <Modal
      title="Enter your email to continue"
      handleClose={() => props.history.goBack()}
    >
      <EmailForm {...props} />
    </Modal>
  )
}

export default connect(state => ({
  planParams: getPlanParams(state),
  sessionId: state.session.id,
}))(Email)



// WEBPACK FOOTER //
// ./src/components/modals/Email.js